import { ListGuesser } from 'react-admin'
import ProvinceIcon from '@material-ui/icons/LocationOn';

export default {
  list: ListGuesser,

  icon: ProvinceIcon,
}